import axios from "axios";
import { message } from "antd";
import isEmpty from "../validation/is-empty";
import { forOwn } from "lodash";
import moment from "moment";
import { FINALIZED } from "./constants";

/**
 *
 * @param {edit} additional fields
 * additional fields [{ setField, field }]
 */
export const edit = ({
  record,
  setState,
  setErrors,
  setRecords,
  url,
  date_fields = [],
  period_covered_fields = [],
}) => {
  axios
    .get(url + record._id)
    .then((response) => {
      let record = { ...response.data };

      //date
      forOwn(record, (value, key) => {
        if (date_fields.includes(key)) {
          record[key] = value ? moment(value) : null;
        }
      });

      forOwn(record, (value, key) => {
        if (period_covered_fields.includes(key)) {
          record[key] =
            (value || [])?.length > 0
              ? [moment(value[0]), moment(value[1])]
              : null;
        }
      });

      setState(record);

      if (setErrors) {
        setErrors({});
      }

      if (setRecords) {
        setRecords([]);
      }
    })
    .catch((err) => console.log(err));
};

export const onDelete = ({
  id,
  url,
  user,
  cb,
  additional_data,
  setLoadingState,
  delete_label = "cancel",
}) => {
  console.log("setLoadingState type:", typeof setLoadingState);
  if (setLoadingState) {
    setLoadingState((prevState) => ({
      ...prevState,
      [delete_label]: true,
    }));
  }

  axios
    .delete(url + id, {
      data: {
        user,
        additional_data,
      },
    })
    .then((response) => {
      message.success(`Transaction Cancelled`);

      if (setLoadingState) {
        setLoadingState((prevState) => ({
          ...prevState,
          [delete_label]: false,
        }));
      }

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      console.log(err);
      message.error(err.response.data.message);

      if (setLoadingState) {
        setLoadingState((prevState) => ({
          ...prevState,
          [delete_label]: false,
        }));
      }

      if (cb) {
        cb(err);
      }
    });
};

export const onAddItem = ({ item, items, setItems }) => {
  setItems([...items, item]);
};

export const onDeleteItem = ({ field, index, setState, cb }) => {
  let arr;
  setState((prevState) => {
    arr = [...prevState[field]];
    arr.splice(index, 1);
    return {
      ...prevState,
      [field]: arr,
    };
  });
  if (cb) cb(arr);
};

export const onSubmit = ({
  values,
  auth,
  url,
  setErrors,
  setState,
  date_fields = [],
  period_covered_fields = [],
  setLoading,
  cb,
  setLoadingState,
}) => {
  const form_data = {
    ...values,
    user: auth.user,
  };

  const loading = message.loading("Loading...", 0);

  let promise;
  const id = values._id;
  if (isEmpty(id)) {
    promise = axios.put(url, form_data);
  } else {
    promise = axios.post(url + id, form_data);
  }

  if (setLoading) setLoading(true);

  if (setLoadingState)
    setLoadingState((prevState) => ({
      ...prevState,
      save: true,
    }));
  promise
    .then(({ data }) => {
      if (setLoadingState)
        setLoadingState((prevState) => ({
          ...prevState,
          save: false,
        }));
      loading();
      if (setLoading) setLoading(false);
      message.success("Transaction Saved");

      //date
      forOwn(data, (value, key) => {
        if (date_fields.includes(key)) {
          data[key] = moment(value);
        }
      });

      forOwn(data, (value, key) => {
        if (period_covered_fields.includes(key)) {
          data[key] = !isEmpty(value)
            ? [moment(value[0]), moment(value[1])]
            : [];
        }
      });

      if (setState) {
        setState(data);
      }
      setErrors({});
      if (cb) cb();
    })
    .catch((err) => {
      if (setLoadingState)
        setLoadingState((prevState) => ({
          ...prevState,
          save: false,
        }));
      if (setLoading) setLoading(false);
      console.log(err);
      loading();
      message.error("You have an invalid input");
      setErrors(err.response.data);
    });
};

export const onSearch = ({
  search_keyword = "",
  url,
  page,
  page_size = 10,
  setCurrentPage,
  setRecords,
  setTotalRecords,
  setErrors,
  setLoadingState,
  advance_search = {},
  additional_parameters = {},
  setSearch,
  cb = null,
}) => {
  setCurrentPage(page);
  if (setLoadingState) {
    setLoadingState((prevState) => ({
      ...prevState,
      search: true,
    }));
  }

  const form_data = {
    page,
    page_size,
    s: search_keyword,
    advance_search,
    ...additional_parameters,
  };

  axios
    .post(url + "paginate", form_data)
    .then((response) => {
      setRecords([...response.data.docs]);
      setTotalRecords(response.data.total);

      if (setLoadingState) {
        setLoadingState((prevState) => ({
          ...prevState,
          search: false,
        }));
      }

      if (response.data.total <= 0) {
        message.success("No records found");
      }

      if (setSearch) {
        setSearch(true);
      }

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      console.log(err);
      message.error("There was an error processing your request");
      setErrors(err?.response?.data);

      if (setLoadingState) {
        setLoadingState((prevState) => ({
          ...prevState,
          search: false,
        }));
      }
    });
};

export const onSubmitModal = ({
  values,
  setField,
  auth,
  url,
  setErrors,
  setVisible,
  setLoadingState,
  index,
}) => {
  const form_data = {
    ...values,
    user: auth.user,
  };
  const loading = message.loading("Loading...", 0);

  if (setLoadingState)
    setLoadingState((prevState) => ({
      ...prevState,
      save: true,
    }));

  axios
    .put(url, form_data)
    .then(({ data }) => {
      loading();
      message.success("Transaction Saved");
      setErrors({});
      if (setLoadingState)
        setLoadingState((prevState) => ({
          ...prevState,
          save: false,
        }));

      setField(data, index);
      setVisible(false);
    })
    .catch((err) => {
      console.log(err);
      loading();
      message.error("You have an invalid input");
      setErrors(err.response.data);
      if (setLoadingState)
        setLoadingState((prevState) => ({ ...prevState, save: false }));
    });
};

export const onChange = ({ key, value, setState }) => {
  setState((prevState) => ({
    ...prevState,
    [key]: value,
  }));
};

export const onChangeSetting = ({ key, value }) => {
  const form_data = {
    key,
    value,
  };
  axios.post("/api/account-settings", form_data);
};

export const getDateTimeNow = () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/settings/date")
      .then((response) => {
        resolve(response.data.date);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const onUpdateStatus = ({
  url,
  state,
  approval_status = "",
  user,
  cb,
  remarks = null,
  update_url = "update-status",
  status_key = "status",
  button_name = "close",
  onPurchaseReturnCallback = null,
  others = {},
  setErrors,
  setLoadingState,
}) => {
  if (setLoadingState) {
    setLoadingState((prevState) => ({
      ...prevState,
      [button_name]: true,
    }));
  }

  axios
    .post(`${url}${state._id}/${update_url}`, {
      [status_key]: {
        approval_status: approval_status,
        user,
        remarks,
      },
      status_key,
      others,
    })
    .then((response) => {
      if (setLoadingState) {
        setLoadingState((prevState) => ({
          ...prevState,
          [button_name]: false,
        }));
      }

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      if (setErrors) {
        setErrors(err?.response?.data);
      }
      if (setLoadingState) {
        setLoadingState((prevState) => ({
          ...prevState,
          [button_name]: false,
        }));
      }

      if (cb) {
        cb();
      }
      message.error("There was an error updating transaction status");
    });
};

export const hasAccess = ({ auth, access, location }) => {
  const length = (auth?.user?.permissions || [])
    .filter((o) => {
      /* if (location?.pathname?.startsWith(o.route)) {
        console.log(o);
        console.log(o.access);
      } */
      /* return (
        location?.pathname?.startsWith(o.route) && o.access?.includes(access)
      ); */

      return location?.pathname === o.route && o.access?.includes(access);
    })
    .map((o) => o.route).length;

  return length > 0;
};

export const onFinalize = ({
  id,
  url,
  user,
  edit,
  setState,
  setErrors,
  setRecords,
  date_fields,
}) => {
  return new Promise((resolve, reject) => {
    const form_data = {
      status: {
        approval_status: FINALIZED,
        user,
      },
    };
    axios
      .post(url + id + "/update-status", form_data)
      .then((response) => {
        message.success("Transaction Finalized", 0.1);
        edit({
          record: response.data,
          setState,
          setErrors,
          setRecords,
          url,
          date_fields,
        });
        resolve(true);
      })
      .catch((err) => {
        message.error(err.response.data.message);
        reject(err);
      });
  });
};

export const onDeleteRecord = ({ records, index, setRecords, url, user }) => {
  const arr = [...records];
  const record = { ...arr[index] };

  axios
    .delete(url + record._id, {
      data: {
        user,
      },
    })
    .then((response) => {
      message.success("Transaction Deleted");
    })
    .catch((err) => {
      message.error(err.response.data.message);
    });

  arr.splice(index, 1);
  setRecords(arr);
};

export const onSubmitForm = ({ url, setErrors, additional_url = "" }) => {
  const loading = message.loading("Loading...", 0);

  axios
    .post(url + additional_url)
    .then((response) => {
      loading();
      if (response.data) {
        window.open(`/public/reports/${response.data.filename}`);
      }
    })
    .catch((err) => {
      console.log(err);
      loading();
      message.error("There was an error processing your request");
      setErrors(err?.response?.data);
    });
};

export const onFinish = ({
  loading,
  onSubmit,
  state,
  auth,
  url,
  setErrors,
  setState,
  date_fields,
  setLoading,
  setLoadingState,
  cb = null,
  setSearch,
}) => {
  if (!loading) {
    onSubmit({
      values: state,
      auth,
      url,
      setErrors,
      setState,
      date_fields,
      setLoading,
      setLoadingState,
      cb,
      setSearch,
    });
  }
};

export const onUpdateSubmit = ({
  url,
  state,
  form_data = {},
  additional_url = "",
}) => {
  axios
    .post(`${url}${state._id}/${additional_url}`, form_data)
    .then((response) => {
      message.success(`${additional_url} updated`);
    })
    .catch((err) => {
      message.error("There was an error updating transaction status");
    });
};
